export default __webpack_public_path__ + "static/media/MD.4c105d69.png";